import React from 'react'

const ImpressumPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="text-3xl font-bold mb-8 text-center">Impressum</h1>
        
        <div className="bg-white rounded-lg shadow-lg p-8 space-y-8">
          <div className="text-center">
            <h2 className="text-2xl font-bold mb-4">PhoneMedic</h2>
            <div className="space-y-2 text-lg">
              <p><strong>Konrad Blersch</strong></p>
              <p>Wahlenstraße 27</p>
              <p>93047 Regensburg</p>
            </div>
          </div>
          
          <div className="border-t pt-6">
            <h3 className="text-xl font-semibold mb-4">Kontakt</h3>
            <div className="space-y-2">
              <p><strong>Tel:</strong> +49 (0) 160 5010907</p>
              <p><strong>Mail:</strong> service@phone-medic.de</p>
            </div>
          </div>
          
          <div className="border-t pt-6">
            <h3 className="text-xl font-semibold mb-4">Geschäftsführer</h3>
            <div className="space-y-2">
              <p>Konrad Blersch</p>
              <p>PhoneMedic Einzelunternehmen</p>
              <p><strong>Steuer-ID:</strong> 244/205/61810</p>
            </div>
          </div>
          
          <div className="border-t pt-6">
            <h3 className="text-xl font-semibold mb-4">Alternative Streitbeilegung</h3>
            <p className="text-gray-700">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
              <a href="https://ec.europa.eu/consumers/odr" className="text-indigo-600 hover:underline ml-1" target="_blank" rel="noopener noreferrer">
                https://ec.europa.eu/consumers/odr
              </a>. 
              Zur Teilnahme an einem Streitbeilegungsverfahren sind wir nicht verpflichtet und nicht bereit.
            </p>
          </div>
          
          <div className="border-t pt-6">
            <h3 className="text-xl font-semibold mb-4">Soziale Medien Accounts</h3>
            <div className="space-y-2">
              <p>
                <strong>Instagram:</strong> 
                <a href="https://www.instagram.com/phonemedic_de/" className="text-indigo-600 hover:underline ml-1" target="_blank" rel="noopener noreferrer">
                  https://www.instagram.com/phonemedic_de/
                </a>
              </p>
              <p>
                <strong>TikTok:</strong> 
                <a href="https://www.tiktok.com/@phonemedic_de" className="text-indigo-600 hover:underline ml-1" target="_blank" rel="noopener noreferrer">
                  https://www.tiktok.com/@phonemedic_de
                </a>
              </p>
              <p>
                <strong>LinkedIn:</strong> 
                <a href="https://www.linkedin.com/in/konrad-blersch-273b2624b/" className="text-indigo-600 hover:underline ml-1" target="_blank" rel="noopener noreferrer">
                  https://www.linkedin.com/in/konrad-blersch-273b2624b/
                </a>
              </p>
            </div>
          </div>
          
          <div className="border-t pt-6">
            <h3 className="text-xl font-semibold mb-4">Haftung und Urheberrecht</h3>
            <div className="space-y-4 text-gray-700">
              <div>
                <h4 className="font-semibold text-gray-900 mb-2">Verantwortlichkeit für Inhalte</h4>
                <p>
                  Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. 
                  Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht unter der Verpflichtung, übermittelte oder gespeicherte fremde 
                  Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                </p>
              </div>
              
              <div>
                <h4 className="font-semibold text-gray-900 mb-2">Haftung für Links</h4>
                <p>
                  Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir 
                  für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige 
                  Anbieter oder Betreiber der Seiten verantwortlich.
                </p>
              </div>
              
              <div>
                <h4 className="font-semibold text-gray-900 mb-2">Urheberrecht</h4>
                <p>
                  Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. 
                  Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes 
                  bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                </p>
              </div>
              
              <p className="mt-4 text-sm">
                Wir sind bereit, rechtswidrige Inhalte bei Kenntnis umgehend zu entfernen.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ImpressumPage